import { Link } from 'react-router-dom';

const footerColumns = [
  {
    title: 'Categories',
    links: [
      { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
      { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html' },
      { name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html' },
      { name: 'Jackets', url: 'https://kaspreadsheet.com/category-914-Jackets.html' },
    ],
  },
  {
    title: 'More Categories',
    links: [
      { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html' },
      { name: 'Headwear', url: 'https://kaspreadsheet.com/category-916-Headwear.html' },
      { name: 'Sets', url: 'https://kaspreadsheet.com/category-917-Sets.html' },
      { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html' },
    ],
  },
  {
    title: 'Browse',
    links: [
      { name: 'Jersey', url: 'https://kaspreadsheet.com/category-919-Jersey.html' },
      { name: 'Accessories', url: 'https://kaspreadsheet.com/category-920-Accessories.html' },
      { name: 'Bags', url: 'https://kaspreadsheet.com/category-921-Bags.html' },
      { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Bags.html' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Bags.html' },
      { name: 'OtherStuff', url: 'https://kaspreadsheet.com/search-924/name/Bags.html' },
      { name: 'Blog', url: '/shopping-guide' },
      { name: 'Contact', url: '/shopping-guide' },
    ],
  },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-background-50">
      {/* Top section */}
      <div className="w-full px-4 md:px-8 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
            {/* Left: Brand + subscribe */}
            <div className="lg:w-1/3">
              <Link to="/" className="cursor-pointer">
                <span className="font-heading text-2xl font-semibold text-white">
                  LitBuy Spreadsheets
                </span>
              </Link>
              <p className="mt-4 text-sm text-foreground-300 leading-relaxed max-w-sm">
                Smart LitBuy Spreadsheet resources, guides, and data insights for modern shoppers. Explore 15+ product categories with expert-curated content.
              </p>
              <div className="mt-6">
                <p className="font-heading text-xl text-white italic">
                  Smart Sheets.
                </p>
                <p className="font-heading text-xl text-primary-400 italic mt-0.5">
                  Better Shopping.
                </p>
              </div>
            </div>

            {/* Right: Link columns */}
            <div className="lg:w-2/3 grid grid-cols-2 sm:grid-cols-4 gap-8">
              {footerColumns.map((col) => (
                <div key={col.title}>
                  <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">
                    {col.title}
                  </h4>
                  <ul className="space-y-2.5">
                    {col.links.map((link) => (
                      <li key={link.name}>
                        {link.url.startsWith('http') ? (
                          <a
                            href={link.url}
                            target="_blank"
                            rel="noopener nofollow"
                            className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer"
                          >
                            {link.name}
                          </a>
                        ) : (
                          <Link
                            to={link.url}
                            className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer"
                          >
                            {link.name}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-8 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} LitBuy Spreadsheets. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <Link to="/" className="text-xs text-foreground-400 hover:text-white transition-colors cursor-pointer">
                Privacy Policy
              </Link>
              <Link to="/" className="text-xs text-foreground-400 hover:text-white transition-colors cursor-pointer">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}